var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127;}\n\t.st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stroke",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41,41H11c-1.1,0-2-0.9-2-2V7c0-1.1,0.9-2,2-2h30c1.1,0,2,0.9,2,2v32C43,40.1,42.1,41,41,41z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 9,
    y1: 13,
    x2: 43,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 43,
    y1: 31,
    x2: 9,
    y2: 31
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 36,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M17,41v4c0,1.1-0.9,2-2,2h-2c-1.1,0-2-0.9-2-2v-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M35,41v4c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2v-4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 21,
    y1: 9,
    x2: 31,
    y2: 9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "filled"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M21,10h10c0.5522,0,1-0.4478,1-1s-0.4478-1-1-1H21c-0.5522,0-1,0.4478-1,1S20.4478,10,21,10z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 16,
    cy: 36,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 36,
    cy: 36,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    className: "st17",
    width: 32,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,45c0,1.6543,1.3457,3,3,3h2c1.6543,0,3-1.3457,3-3v-1h-8V45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,4H11C9.3457,4,8,5.3457,8,7v32c0,1.3019,0.8385,2.4016,2,2.8157c0,0,1,0.1843,2,0.1843c2,0,6,0,6,0h16c0,0,4,0,6,0 c1,0,2-0.1843,2-0.1843c1.1615-0.4141,2-1.5138,2-2.8157V7C44,5.3457,42.6543,4,41,4z M21,8h10c0.5522,0,1,0.4478,1,1 s-0.4478,1-1,1H21c-0.5522,0-1-0.4478-1-1S20.4478,8,21,8z M16,38c-1.1046,0-2-0.8954-2-2c0-1.1046,0.8954-2,2-2s2,0.8954,2,2 C18,37.1046,17.1046,38,16,38z M36,38c-1.1046,0-2-0.8954-2-2c0-1.1046,0.8954-2,2-2s2,0.8954,2,2C38,37.1046,37.1046,38,36,38z  M42,31H10V13h32V31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,45c0,1.6543,1.3457,3,3,3h2c1.6543,0,3-1.3457,3-3v-1h-8V45z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.6554aadc8dcc8abe69fb6737be989652.svg";
export { ForwardRef as ReactComponent };